import { __assign } from './../../../external_lib/tslib/tslib.es6.js';
import React__default from 'react';
var CheckMark = function (props) {
  return React__default.createElement("svg", __assign({
    width: "24",
    height: "24",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("path", {
    d: "M13.5286 3.52881L6 11.0575L3.13802 8.19548L2.19531 9.13818L6 12.9429L14.4714 4.47152L13.5286 3.52881Z",
    fill: "currentColor"
  }));
};
export { CheckMark as default };
//# sourceMappingURL=CheckMark.js.map
